import { render, staticRenderFns } from "./Lembrete-Medicacao-Listagem.vue?vue&type=template&id=3b20c553&scoped=true&"
import script from "./Lembrete-Medicacao-Listagem.vue?vue&type=script&lang=js&"
export * from "./Lembrete-Medicacao-Listagem.vue?vue&type=script&lang=js&"
import style0 from "./Lembrete-Medicacao-Listagem.vue?vue&type=style&index=0&id=3b20c553&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20c553",
  null
  
)

component.options.__file = "Lembrete-Medicacao-Listagem.vue"
export default component.exports